<template>
    <el-dialog
      title=""
      :visible.sync="$store.state.poiListObj.groupFalg"
      width="90%"
      :append-to-body="true"
      :close-on-click-modal="false"
      center>
        
        <div class="wrapper wrapper-content animated fadeInRight">
          <div class="ibox-content m-b-sm border-bottom">
            <div class="row form-horizontal">
              <div class="form-group  margin-0">
                <label class="col-sm-2 control-label">{{
                  $t("message.title")
                }}</label>
                <div class="col-sm-8">
                  <div>
                    <el-input v-model="name" ></el-input>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class>
                    <el-button type="primary" @click="search">{{
                      $t("message.Search")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="ibox float-e-margins">
                <div class="ibox-content">
                  <div class="row table-responsive" style="padding-bottom:60px;">
                    <div class="col-xs-12">
                      {{ rows.length }}{{ $t("message.datagridresult") }}
                    </div>
                    <el-table
                      :data="rows"
                      border
                      style="width: 100%"
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      @sort-change="sortChange"
                      stripe
                      row-key="id"
                      @row-dblclick="handleDbClick"
                    >
                      <el-table-column type="selection" width="55"></el-table-column>
                      <el-table-column
                        prop="name"
                        :show-overflow-tooltip="true"
                        label="Name"
                        min-width="200"
                      ></el-table-column>
                      <el-table-column
                        prop="createdTime"
                        label="Create time"
                        width="170"
                      ></el-table-column>
                    </el-table>
                    <el-col :span="24" class="el-table_footertoolbar">
                      <el-pagination 
                        layout="total, sizes, prev, pager, next, jumper" 
                        @size-change="handleSizeChange" 
                        @current-change="handleCurrentChange" 
                        :page-sizes="[10, 20, 50, 100]" 
                        :page-size="pagesize" 
                        :total="total" 
                        style="float:right;">
                      </el-pagination>
                    </el-col>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.state.poiListObj.groupFalg = false">Cancel</el-button>
        <el-button type="primary" @click="addEvent">Confirm</el-button>
      </span>
    </el-dialog>
</template>
<script>
import config from "../../config";
export default {
  name: "groupDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      name: "",
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "DESC",
      sortField: "id",
    };
  },
  methods: {
    cancel: function() {
      this.$store.commit("seteventlist", { string: "", boolean: false });
    },
    async init() {
      let objdata = this.getAuthObj();
      objdata.searchBy = {};
      objdata.sortBy = {};
      objdata.searchBy.name = this.name;
      objdata.sortBy[this.sortField] = this.sortType;
      objdata.startRow = this.page*this.pagesize;
      objdata.maxRows = this.pagesize;
      objdata.apiUrl = this.apiConfig.poiList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == this.TOKEN_EXPIRED){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      
      let list = null;
      for (list of data.data.payload) {
        list.createdTime = this.dateFormat(list.createdTime);
      }
      this.rows = data.data.payload;
      this.total = data.data.totalRows;
    },
    search() {
      this.init();
    },
    handleSizeChange:function(val){
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange:function(val){
      this.page = val-1;
      this.init();
    },
    handleSelectionChange:function(val){
      this.multipleSelection = val;
    },
    handleDbClick:function(row){
    },
    sortChange:function(val){
    },
    addEvent:function(){
      this.$store.state.poiListObj.callback(this.multipleSelection)
    },
  },
  computed:{
      _obj(){
        return this.$store.state.poiListObj.groupFalg
      }
  },
  watch: {
    _obj:function(){
      if(this.$store.state.poiListObj.groupFalg){
        this.init();
      }
    }
  },
  mounted() {
    // this.init();
  },
};
</script>
